import axios from "axios";
import { getCookie } from "./getCookie";

export const createAPIwithNextValue = (path: string) => {
  return axios.create({
    baseURL: `${path}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getCookie("token")}`,
    },
  });
};
